import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { useRouter } from '../../../router';
const _preserve = React.version;



import { Button, Checkbox, Form, Input, Link, Select, TimeInput } from "@cloudscape-design/components";

import { FormField, Modal, Pagination, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiRefresh } from '@mdi/js';
import { Icon } from '@mdi/react';
import { format, parse } from 'date-fns';
import DPModal from '../../../../../components/DPModal';
import Favorites from '../../../../../components/extras/Favorites';
import MPModal from '../../../../../components/MPModal';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm } from '../../../../../resources/types';
import { addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';


type ItemLog = { idLog: number; idUser: number; date: string; time: string; log: string; route: string; displayName: string; ip: string; data: any, type: string; id: number, site: string, module: string };
const pageSize = 20;
export const CommCalendarEventsPage = () => {
    const { menu, parameters, data } = useGlobalState();

    const { navigate } = useRouter();
    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [modalPreview, setModalPreview] = useState(false);
    const [showSystem, setShowSystem] = useState(false);
    const [idUser, setIdUser] = useState(0);

    const [events, setEvents] = useState<any[]>([]);
    const [event, setEvent] = useState<any>();
    const [categories, setCategories] = useState<any>([]);


    const [filterValue, setFilterValue] = useState("");

    useEffect(() => {
        if (parameters.date && parameters.date !== "")
            handleRefresh()
    }, [parameters.date]);
    const handleRefresh = async () => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/calendar/list',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    month: parameters.month,
                    year: parameters.year,
                    orderBy: "dateStart",
                    order: "asc"
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const dataWeb = await response.json();
            if (dataWeb && dataWeb.events) {
                setEvents(dataWeb.events.map((event: any) => ({
                    ...event,
                    startTime: !!event?.dateStart && event.dateStart !== "" ? format(parse(event.dateStart, "dd-MM-yyyy HH:mm", new Date()), "HH:mm") : "",
                    startDate: !!event?.dateStart && event.dateStart !== "" ? format(parse(event.dateStart, "dd-MM-yyyy HH:mm", new Date()), "dd-MM-yyyy") : "",
                    endTime: !!event?.dateEnd && event.dateEnd !== "" ? format(parse(event.dateEnd, "dd-MM-yyyy HH:mm", new Date()), "HH:mm") : "",
                    endDate: !!event?.dateEnd && event.dateEnd !== "" ? format(parse(event.dateEnd, "dd-MM-yyyy HH:mm", new Date()), "dd-MM-yyyy") : "",
                })));
            }
            if (dataWeb && dataWeb.categories) {
                setCategories(dataWeb.categories.map((category: any) => ({ label: category.category, value: category.idCategory })));
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleUpdate = async () => {
        try {
            setLoading(true);
            let body = {
                idEvent: event?.idEvent,
                title: event?.title,
                description: event?.description,
                idCategory: event?.idCategory,
                dateStart: event?.startDate + " " + event?.startTime,
                dateEnd: event?.endDate + " " + event?.endTime,
                month: parameters.month,
                year: parameters.year,
                idUser: idUser,
                orderBy: "dateStart",
                order: "asc"

            }
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/calendar/update',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify(body)
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const dataWeb = await response.json();
            addNotificationStatus(dataWeb, setData);
            if (dataWeb && dataWeb.events) {
                setEvents(dataWeb.events.map((event: any) => ({
                    ...event,
                    startTime: format(parse(event.dateStart, "dd-MM-yyyy HH:mm", new Date()), "HH:mm"),
                    startDate: format(parse(event.dateStart, "dd-MM-yyyy HH:mm", new Date()), "dd-MM-yyyy"),
                    endTime: format(parse(event.dateEnd, "dd-MM-yyyy HH:mm", new Date()), "HH:mm"),
                    endDate: format(parse(event.dateEnd, "dd-MM-yyyy HH:mm", new Date()), "dd-MM-yyyy"),
                })));
            }
            if (dataWeb && dataWeb.categories) {
                setCategories(dataWeb.categories.map((category: any) => ({ label: category.category, value: category.idCategory })));
            }
            setEvent(undefined);
            handleRefresh();
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    const filtered = events.filter((item) => {
        const searchWords = filterValue.toLowerCase().split(/\s+/).filter(Boolean);
        const text = [item.idEvent, item.title, item.description, item.category].join(" ").toLowerCase().replace(/[^a-z0-9]/g, "");
        return searchWords.every((word) => text.includes(word.replace(/[^a-z0-9]/g, "")));
    });

    const paginated = filtered.slice((currentPageIndex - 1) * pageSize, currentPageIndex * pageSize);

    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={
                        <Favorites />

                    }>Calendario de eventos</Header>
                    <Table
                        stickyHeader
                        stripedRows
                        variant="embedded"

                        columnDefinitions={[
                            {
                                id: 'idEvent',
                                header: 'ID',
                                cell: (item: any) => <Link onClick={() => setEvent(item)}>{item.idEvent}</Link>,
                                width: 70,
                            },
                            {
                                id: 'log',
                                header: 'Título',
                                cell: (item: any) => <FormField label={item.category}>
                                    {item.title}
                                </FormField>,
                            },
                            {
                                id: 'desde',
                                header: 'Desde',
                                cell: (item: any) => <FormField label={item.startDate}>
                                    {item.startTime}
                                </FormField>,
                            },
                            {
                                id: 'hasta',
                                header: 'Hasta',
                                cell: (item: any) => <FormField label={item.endDate}>
                                    {item.endTime}
                                </FormField>,
                            },
                            {
                                id: 'idCopy',
                                header: 'ID',
                                cell: (item: any) => <Link onClick={() => setEvent({
                                    ...item,
                                    idEvent: 0
                                })}>Copiar</Link>,
                                width: 70,
                            },
                        ]}

                        pagination={
                            filtered.length > pageSize && (
                                <Pagination
                                    currentPageIndex={currentPageIndex}
                                    pagesCount={Math.ceil(filtered.length / pageSize)}
                                    onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                />
                            )
                        }
                        filter={
                            <Form actions={<Button onClick={() => setEvent({ idEvent: 0, idUser: idUser })} variant="primary">Nuevo</Button>}
                                secondaryActions={
                                    < SpaceBetween direction="horizontal" size="xs" >


                                        <div style={{ width: 130 }}>
                                            <MPModal
                                                width={120}
                                                today prevMonth nextMonth
                                                end={new Date()}
                                                date={`${parameters.period}`}
                                                onConfirm={(date) => {
                                                    setParameters({ ...parameters, period: date.period, month: date.month, year: date.year });
                                                }}
                                            />
                                        </div>
                                        <Button style={{ root: btnIconForm }} onClick={() => handleRefresh()}><Icon path={mdiRefresh} size={1} /></Button>

                                    </SpaceBetween >
                                } />
                        }
                        items={paginated}
                    />
                    {!!event && (
                        <Modal size="medium" visible={!!event} onDismiss={() => setEvent(undefined)} header={<Header>{event?.idEvent === 0 ? "Nuevo evento" : `Evento #${event?.idEvent}`}</Header>}>
                            <Form actions={<Button variant="primary" onClick={() => handleUpdate()}>{event?.idEvent === 0 ? "Ingresar" : `Actualizar`}</Button>}
                                secondaryActions={
                                    <Button variant="link" onClick={() => setEvent(undefined)}>Cerrar</Button>
                                }>
                                <SpaceBetween size="s" direction="vertical">
                                    <FormField label="Título">
                                        <Input value={event?.title || ""} onChange={(e) => setEvent({ ...event, title: e.detail.value })} />
                                    </FormField>
                                    <FormField label="Descripción" constraintText="Opcional">
                                        <Input value={event?.description || ""} onChange={(e) => setEvent({ ...event, description: e.detail.value })} />
                                    </FormField>
                                    <SpaceBetween size="s" direction="horizontal">
                                        <FormField label="Categoría">
                                            <Select options={categories || []} selectedOption={categories?.find((c: any) => Number(c.value) === Number(event?.idCategory))} onChange={(e) => setEvent({ ...event, idCategory: Number(e.detail.selectedOption?.value) })} />
                                        </FormField>

                                        <FormField label="Extensión">
                                            <Checkbox checked={event?.isAllDay || false} onChange={(e) => setEvent({ ...event, isAllDay: e.detail.checked })}>
                                                Todo el día
                                            </Checkbox>
                                        </FormField>
                                    </SpaceBetween>

                                    <SpaceBetween size="s" direction="horizontal">
                                        <FormField label="Desde">
                                            <DPModal width={120} date={event?.startDate || ""} onConfirm={(date) => setEvent({ ...event, startDate: date })} />
                                        </FormField>
                                        <FormField label="Hora">
                                            <div style={{ width: 80 }}>
                                                <TimeInput value={event?.startTime || ""} onChange={(e) => setEvent({ ...event, startTime: e.detail.value })} disabled={event?.isAllDay || false} format="hh:mm" />
                                            </div>
                                        </FormField>
                                        <FormField label="Hasta">
                                            <DPModal width={120} date={event?.endDate || ""} onConfirm={(date) => setEvent({ ...event, endDate: date })} />
                                        </FormField>
                                        <FormField label="Hora">

                                            <div style={{ width: 80 }}>
                                                <TimeInput value={event?.endTime || ""} onChange={(e) => setEvent({ ...event, endTime: e.detail.value })} disabled={event?.isAllDay || false} format="hh:mm" />
                                            </div>
                                        </FormField>
                                    </SpaceBetween>
                                </SpaceBetween>
                            </Form>
                        </Modal>
                    )
                    }

                </SpaceBetween >
            }
        />
    );
};
